/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import React from 'react';
import type { FeatureFlags } from '@atlaskit/editor-common/types';
import type { NestedRendererType } from './ui/Renderer/types';

export type RendererContextProps = {
	featureFlags?: FeatureFlags;
	// Keep this uninitialized it will be set to true in the top level renderer
	isTopLevelRenderer?: boolean;
	// used for analytics to track the type of nested renderer this is
	nestedRendererType?: NestedRendererType;
	// IANA timezone string for consistent date formatting between SSR and client
	timeZone?: string;
};

const RendererContext = React.createContext({});

export const useRendererContext = (): RendererContextProps => React.useContext<RendererContextProps>(RendererContext);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const RendererContextProvider: React.Provider<{}> = RendererContext.Provider;
